import React, { useEffect, useRef } from 'react'

import { useChatContext } from 'components/Artefacts/Chat/context'
import Avatar from 'components/common/Avatar'
import Text from 'components/common/Text'
import { userTypes } from 'helpers/user'

import Message from './Message'
import { Container, Wrapper, AvatarWrapper, Identity } from './styles'

const ChatMessages = () => {
    const { localUserId, chatMessages = [] } = useChatContext()

    // needed for scrolling to bottom when new chat message comes
    // because latest message is at the end of the list
    const emptySpan = useRef()
    useEffect(() => {
        emptySpan && emptySpan.current.scrollIntoView({ behavior: 'smooth' })
    }, [chatMessages])

    return (
        <Container>
            <Wrapper>
                {chatMessages.map((msg, index) => {
                    const { chat_id, message, name, user_id, timestamp } = msg
                    const userType =
                        name?.toLowerCase() === userTypes.TEACHER
                            ? userTypes.TEACHER
                            : userTypes.STUDENT
                    const isLocal = localUserId === user_id
                    const isPrevMsgBySameUser =
                        chatMessages[index - 1]?.user_id === user_id
                    const isNextMsgBySameUser =
                        chatMessages[index + 1]?.user_id === user_id

                    const msgProps = {
                        isLocal,
                        message,
                        timestamp,
                        needMargin: !isNextMsgBySameUser,
                    }

                    return isPrevMsgBySameUser ? (
                        <Message key={chat_id} {...msgProps} />
                    ) : (
                        <React.Fragment key={chat_id}>
                            <Identity isLocal={isLocal}>
                                <AvatarWrapper>
                                    <Avatar
                                        uuid={user_id}
                                        userType={userType}
                                        withBackground
                                    />
                                </AvatarWrapper>
                                <Text level="3" color="#000008cc">
                                    {name}
                                </Text>
                            </Identity>
                            <Message {...msgProps} />
                        </React.Fragment>
                    )
                })}
                <span ref={emptySpan} />
            </Wrapper>
        </Container>
    )
}

export default ChatMessages
